import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { env } from '@amfam/environment';

import { PhotoUploadRequest, UploadRequestData } from '../models/photo-thumbnail';

@Injectable({ providedIn: 'root' })
export class ClaimPhotoUploadService {
  constructor(private http: HttpClient) {}

  getPhotoDocuments(claimNumber: string) {
    const url = env.documentApi + 'documents?classification=Claims&ClaimNumber=' + claimNumber;
    return this.http.get(url);
  }

  buildUploadData(photoData: UploadRequestData) {
    const requestObj: PhotoUploadRequest = {
      endUser: {
        name: photoData.userName,
        emailAddress: photoData.emailAddress
      },
      mimeType: photoData.mimeType,
      consumerContentName: photoData.fileName,
      requestedRetryMax: '',
      requestedSecondsToUploadTimeout: '',
      notificationTemplateIdentifier: '',
      destinationApplicationName: 'CATALYST',
      destinationRepositoryTypeIdentifier: 'EDMS',
      documentClassIdentifier: 'ClaimsCenterOperations',
      edmsAttributes: [
        {
          key: 'ContentCategory',
          value: 'ESTIMATES AND RELATED PHOTOS'
        },
        {
          key: 'CategoryType',
          value: 'ESTIMATE RELATED PHOTO'
        },
        {
          key: 'ContentDescription',
          value: photoData.description
        },
        {
          key: 'ContentLanguage',
          value: 'ENGLISH'
        },
        {
          key: 'DocumentTitle',
          value: photoData.categoryType
        },
        {
          key: 'AuthorIdentifier',
          value: 'CUSTOMER'
        },
        {
          key: 'PolicyNumber',
          value: photoData.policyNumber
        },
        {
          key: 'LineOfBusiness',
          value: 'PERSONAL AUTO'
        },
        {
          key: 'DocumentSource',
          value: 'MYACCOUNT-WEBAPPLICATION'
        },
        {
          key: 'SourceSystem',
          value: 'GWCC'
        },
        {
          key: 'ExposureID',
          value: photoData.exposureId
        },
        {
          key: 'DocumentControlNumber',
          value: photoData.uuid
        },
        {
          key: 'SecurityType',
          value: 'UNRESTRICTED'
        },
        {
          key: 'ClaimNumber',
          value: photoData.claimNumber
        },
        /* For future use:
           For latutude and longitude
           Send unsigned double value in string format
           Send object only if lat and long exists
           Format (for both lats and longs):
             {
               "key": "Longitude"
               "value": "-19.5112",
              }
              As I am not implementing lats and longs currently, I am not sending the object.
          */
        {
          key: 'DateOnDocument',
          value: photoData.lastModifiedDate
        },
        {
          key: 'IndexDate',
          value: photoData.indexDate
        },
        {
          key: 'FileOnly',
          value: 'True'
        }
      ],
      applicationUseOnlyAttributes: [
        {
          name: 'appname',
          value: env.afiAppName
        },
        {
          name: 'userId',
          value: photoData.cdhId
        }
      ],
      syntheticUseOnlyAttributes: [
        {
          name: '',
          value: ''
        }
      ],
      transactionId: ''
    };

    if (!env.production) {
      requestObj.edmsAttributes.push({ key: 'Leg', value: 'CTP' });
    }

    return requestObj;
  }
}
